import PropTypes from 'prop-types';
import React from 'react';

import Video from './video';

const ResVideo = ({
  className = 'w-full h-full',
  desktopVideo,
  mobileVideo,
  desktopPoster,
  mobilePoster,
  aspectRatio,
}) => {
  const mobileVideoFile =
    mobileVideo && mobileVideo.filename !== undefined && mobileVideo.filename !== ''
      ? mobileVideo
      : desktopVideo;

  const mobilePosterFile =
    mobilePoster && mobilePoster.filename !== undefined && mobilePoster.filename !== ''
      ? mobilePoster
      : desktopPoster;

  let aspectRatioClass = '';
  let aspectRatioMobileClass = '';
  if (aspectRatio?.desktop === 'vertical-aspect') {
    aspectRatioClass = 'lg:aspect-[195/270]';
  }
  if (aspectRatio?.desktop === 'wide-aspect') {
    aspectRatioClass = 'lg:aspect-[190/120]';
  }
  if (aspectRatio?.desktop === 'square-aspect') {
    aspectRatioClass = 'lg:aspect-square';
  }

  if (aspectRatio?.mobile === 'vertical-aspect') {
    aspectRatioMobileClass = 'mobile:aspect-[195/270]';
  }
  if (aspectRatio?.mobile === 'wide-aspect') {
    aspectRatioMobileClass = 'mobile:aspect-[190/120]';
  }
  if (aspectRatio?.mobile === 'square-aspect') {
    aspectRatioMobileClass = 'mobile:aspect-square';
  }
  return (
    <div className={className}>
      <Video
        className={`${className} backface isolate hidden object-cover lg:block ${aspectRatioClass}`}
        video={desktopVideo}
        poster={desktopPoster}
      />
      <Video
        className={`${className} isolate object-cover lg:hidden ${aspectRatioMobileClass}`}
        video={mobileVideoFile}
        poster={mobilePosterFile}
      />
    </div>
  );
};

ResVideo.propTypes = {
  className: PropTypes.string,
  desktopVideo: PropTypes.shape({
    filename: PropTypes.string,
  }),
  mobileVideo: PropTypes.shape({
    filename: PropTypes.string,
  }),
  desktopPoster: PropTypes.shape({
    filename: PropTypes.string,
  }),
  mobilePoster: PropTypes.shape({
    filename: PropTypes.string,
  }),
  aspectRatio: PropTypes.object,
};

export default ResVideo;
